module.exports = __webpack_public_path__ + "img/duihua.ebc9e3ba.png";